var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bare)?_c('fragment',[_vm._v(_vm._s(_vm.getMessage))]):_c('fragment',[(_vm.parseHtml)?_c('span',{class:_vm.cssClass,domProps:{"innerHTML":_vm._s(_vm.getMessage)}}):_c('span',{class:_vm.cssClass},[_vm._v(_vm._s(_vm.getMessage))])])}
var staticRenderFns = []

export { render, staticRenderFns }